import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {UserSearchResultsPagerService} from "./user-search-results-pager.service";
import {UserSearchResultsService} from "./user-search-results.service";
import {NotifierService} from "../notifier/notifier.service";
import {Dictionary} from "../../model/dictionary";
import {NotificationType} from "../notifier/notification-type.enum";
import {CommonService} from "../../common/common.service";
import {Report} from "../../model/report";
import {HeaderService} from "../header/header.service";
import {UserSearchBoxService} from "../user-search-box/user-search-box.service";
import {forkJoin} from "rxjs/observable/forkJoin";
import {UserReportsService} from "../user-reports/user-reports.service";
import {saveAs} from "file-saver";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {User} from "../../model/user";
import { UserSavedReportsService } from '../user-saved-reports/user-saved-reports.service';
import {BreadcumbsService} from "../breadcumbs/breadcumbs.service";
import {SearchItem} from "../../model/search-item";
import {TopMenuService} from "../top-menu/top-menu.service";
import {AbstractReport} from "../../common/abstract-report";

@Component({
  selector: 'pbc-user-search-results',
  templateUrl: './user-search-results.component.html',
  styleUrls: ['./user-search-results.component.scss']
})
export class UserSearchResultsComponent extends AbstractReport implements OnInit {

  showContactPrompt : boolean = false;

  // public searchItems: Array<SearchItem> = [];
  private loggedUserId: number = null;

  //Akcje na formularzu
  reportShowMoreList: Array<string> = [];
  showDownloadReport: boolean = false;
  showDownloadDemo: boolean = false;
  showContactForm: boolean = false;
  reportToOperateOn: Report;
  showReportShare: boolean = false;

  //Filtry
  contentTypeForFilter: Array<Dictionary> = [];
  fileFormatsForFilter: Array<string> = [];
  thematicsFrequenciesForFilter: Array<Dictionary> = [];
  thematicsAreaForFilter: Array<Dictionary> = [];
  thematicsProductsForFilter: Array<Dictionary> = [];
  thematicsInstitutionForFilter: Array<Dictionary> = [];
  thematicsClientGroupsForFilter: Array<Dictionary> = [];
  showFilterPopup: boolean = false;
  numberOfFilterCriteria: number = 0;
  filteredReportsCounter: number = 0;

  pager: any = new Object();
  private static pageSize: number = 10;
  currentPage: number = 1;

  //Sortowania
  orderByField: string = "publishFrom";
  orderAsc: boolean = false;

  //wyszukwianie w trakcie:
  searchInProgress : boolean = true;

  reports: Array<Report> = [];

  //Formularze
  contactForm : FormGroup;
  shareReportForm : FormGroup;
  private loggedUser : User;
  private static contactFormMessage : string = '';


  constructor(
    private activatedRoute: ActivatedRoute,
    private pagerService: UserSearchResultsPagerService,
    private userSearchResultsService: UserSearchResultsService,
    private userSearchBoxService: UserSearchBoxService,
    private notifierService: NotifierService,
    private commonService: CommonService,
    private headerService: HeaderService,
    private userReportsService: UserReportsService,
    private userSavedReportsService: UserSavedReportsService,
    private breadcumbsService: BreadcumbsService,
    private topMenuService : TopMenuService,
    private userSearchResultsPagerService : UserSearchResultsPagerService
  ) {
    super();
  }

  showFilterPopupClick(show: boolean) {
    this.showFilterPopup = show;
  }

  private getDictionaries() {
    forkJoin(
      this.commonService.getAreaDictionary(),
      this.commonService.getClientGroupsDictionary(),
      this.commonService.getInstitutionDictionary(),
      this.commonService.getProductsDictionary(),
      this.commonService.getFrequencyDictionary(),
      this.commonService.getContentTypeDictionary(),
      this.userReportsService.getFileFormats()
    ).subscribe(([areas, clientGroups, institutions, products, frequencies, contentTypes, fileFormatsResult]) => {
        this.thematicsAreaForFilter = areas;
        this.thematicsClientGroupsForFilter = clientGroups;
        this.thematicsInstitutionForFilter = institutions;
        this.thematicsProductsForFilter = products;
        this.thematicsFrequenciesForFilter = frequencies;
        this.contentTypeForFilter = contentTypes;
        this.fileFormatsForFilter = fileFormatsResult;
      },
      (error) => {
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd! Nie pobrano słowników");
        console.log("Wystąpił błąd! Nie pobrano słowników:", JSON.stringify(error));
      });
  }

  showHideMoreOnReport(reportId: string) {
    let position = this.reportShowMoreList.indexOf(reportId);
    if (position === -1)
      this.reportShowMoreList.push(reportId);
    else
      this.reportShowMoreList.splice(position, 1);
  }
  updateUserReportsCount(){
    let filterParams = {};
    filterParams['id']=this.loggedUserId;
    this.userSavedReportsService.getReportsCount(filterParams).subscribe(
        result => {
          this.topMenuService.userReportsCount.emit(result.record);
        })
  }


  addToFavouritesClick(report: Report) {
    this.commonService.addToFavourites(report.id, this.loggedUserId).subscribe(
      result => {
        this.updateUserReportsCount();
        this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION, "Raport ".concat(report.title, " został dodany do Zapisanych"));

      },
      error => {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd! Raport ".concat(report.title, " nie został dodany do Zapisanych"))
      }
    )
  }

  private orderByClick(orderByField: string) {
    if (orderByField === this.orderByField)
      this.orderAsc = !this.orderAsc;
    else {
      this.orderAsc = true;
      this.orderByField = orderByField;
    }
    this.getReports(true);
  }

  ngOnInit() {
    let authData = JSON.parse(localStorage.getItem('auth_data'));
    this.loggedUser = authData.user;
    this.loggedUserId = authData.user.id;
    const userName = authData.user.firstName + ' ' + authData.user.lastName;
    this.contactForm = new FormGroup({
      'email' : new FormControl({value:this.loggedUser.email, disabled : true},
        [Validators.email, Validators.required]),
      'firstLastName' : new FormControl(
        {value: this.loggedUser.firstName.concat(' ', this.loggedUser.lastName), disabled : true}, Validators.required),
      'phoneNumber' : new FormControl({value: this.loggedUser.workPhone, disabled  : true}),
      'message' : new FormControl(UserSearchResultsComponent.contactFormMessage, Validators.required),
      'sendCopy' : new FormControl(false),
      'agreement' : new FormControl(false, Validators.requiredTrue)
    });

    this.shareReportForm = new FormGroup({
      'email' : new FormControl('', [Validators.email, Validators.required]),
      'message' : new FormControl('Dzień dobry, być może zainteresuje Cię ten raport. Pozdrawiam, ' + userName),
      'sendCopy' : new FormControl('')
    });

    this.headerService.hideLoginRegisterButtons();
    this.headerService.isHomepage(false);
    this.userSearchResultsService.deactivateTopMenu();

    this.getDictionaries();

    this.subscribeSearchStringChange();
    this.getSearchedItems();

    setTimeout(()=>this.breadcumbsService.setSubfolder.emit('Szukaj'),100);
  }

  private subscribeSearchStringChange() {
    this.topMenuService.changeSuggestion.subscribe((searchItems : SearchItem[]) => {
      this.clearFiltersClick(false);
      this.searchItems = searchItems;
      this.headerService.hideRedUnderline();
      this.setPageWithProperData(this.currentPage);
    })
  }

  private getSearchedItems() {
    this.activatedRoute.params.subscribe(queryParams => {
      if (queryParams['searchItems']) {
        this.searchItems = JSON.parse(queryParams['searchItems']);
        this.setPageWithProperData(this.currentPage);
      }
    });
  }

  private getReports(returnResult: boolean, pageNumber: number = 0, pageSize: number = 10, fromSearchBox: boolean = true) {
    let filterParams = this.buildFilterParams(fromSearchBox);
    this.updateUserReportsCount();

    if (returnResult) { //jesli mamy zwrócić wynik, to pobieramy raporty
      this.searchInProgress = true;
      filterParams['pageNumber'] = pageNumber;
      filterParams['pageSize'] = pageSize;

      this.commonService.getUserReports(filterParams).subscribe(
        data => {
          if (data.status != 1) {
            this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania listy raportów');
          } else {

            if (data.record.length > 0 && fromSearchBox)
              this.topMenuService.reloadSuggestions.emit(true)

            this.reports = data.record;
          }
          this.searchInProgress = false;
        },
        error => {
          console.log(error);
          this.searchInProgress = false;
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania listy raportów');
        }
      )
    }
    else //a jak nie zwracamy wyniu, to tylko robimy prefiltracje i zwaracamy liczbe raportow
      this.commonService.prefilterUserReports(filterParams).subscribe(
        data => {
          if (data.status != 1)
            this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Bład w trakcie pobierania danych');
          else
            this.filteredReportsCounter = data.record;
        },
        error => {
          console.log(error);
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania danych');
        }
      )
  }

  private prefilterData() {
    this.commonService.prefilterUserReports(this.buildFilterParams(true)).subscribe (
      result => {
        if (result.status != 1) {
          console.error(result);
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania liczby raportów');
        } else {
          this.countedReports = result.record;
          this.filteredReportsCounter = result.record;
        }
      },
      error => {
        console.error(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania liczby raportów');
      }
    )
  }

  setPageWithProperData(page: number) {
    this.currentPage = page;

    this.commonService.prefilterUserReports(this.buildFilterParams(true)).subscribe(
      result => {
        if (result.status != 1) {
          console.error(result);
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania listy raportów');
        } else {
          this.countedReports = result.record;
          this.filteredReportsCounter = result.record;

          this.pager = this.userSearchResultsPagerService.getPager(result.record, page, UserSearchResultsComponent.pageSize);
          this.getReports(true, page, UserSearchResultsComponent.pageSize, true);
        }
      },
      error => {
        console.error(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania listy raportów');
      }
    )
  }

  modifySelectedElementList(elementList: Array<string>, id: string, showResults?: boolean) {
    if (showResults === undefined)
      showResults = false;

    let position = elementList.indexOf(id);
    if (position === -1)
      elementList.push(id);
    else
      elementList.splice(position, 1);

    this.numberOfFilterCriteria = this.fileFormatsForFilterSelected.length
      + this.thematicsAreaForFilterSelected.length
      + this.thematicsClientGroupsForFilterSelected.length
      + this.thematicsFrequenciesForFilterSelected.length
      + this.thematicsInstitutionForFilterSelected.length
      + this.thematicsInstitutionForFilterSelected.length
      + this.thematicsProductsForFilterSelected.length
      + this.contentTypeForFilterSelected.length;

    if (showResults)
      this.setPageWithProperData(this.currentPage);
    else
      this.prefilterData();
  }

  modifySelectedObjectList(objectList: Array<Dictionary>, object: Dictionary, showResults?: boolean) {
    if (showResults === undefined)
      showResults = false;

    let position = objectList.indexOf(object);
    if (position === -1)
      objectList.push(object)
    else
      objectList.splice(position, 1);

    this.numberOfFilterCriteria = this.fileFormatsForFilterSelected.length
      + this.thematicsAreaForFilterSelected.length
      + this.thematicsClientGroupsForFilterSelected.length
      + this.thematicsFrequenciesForFilterSelected.length
      + this.thematicsInstitutionForFilterSelected.length
      + this.thematicsInstitutionForFilterSelected.length
      + this.contentTypeForFilterSelected.length
      + this.thematicsProductsForFilterSelected.length;

    this.getReports(showResults);
  }

  clearFiltersClick(returnResult) {
    this.fileFormatsForFilterSelected = [];
    this.thematicsAreaForFilterSelected = [];
    this.thematicsClientGroupsForFilterSelected = [];
    this.thematicsFrequenciesForFilterSelected = [];
    this.thematicsInstitutionForFilterSelected = [];
    this.thematicsProductsForFilterSelected = [];
    this.contentTypeForFilterSelected = [];

    this.numberOfFilterCriteria = 0;

    if (returnResult)
      this.setPageWithProperData(1);
  }

  filterReportClick() {
    this.setPageWithProperData(1);
    this.showFilterPopup = false;
  }

  downloadReportClick(report: Report) {
    this.commonService.downloadReportFile(report.id).subscribe(
      data => {
        saveAs(data, report.fileName);
      },
      err => {
        console.log(err);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd! Nie można pobrać wskazanego raportu")
      }
    )
  }

  downloadDemoClick() {
    this.commonService.downloadDemoFile(this.reportToOperateOn.id).subscribe(
      data => {
        saveAs(data, this.reportToOperateOn.demoFileName);
      },
      err => {
        console.log(err);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd! Nie można pobrać DEMO wskazanego raportu")
      }
    )
  }

  downloadDemoOnReportListClick(reportToOperateOn: Report) {
    this.reportToOperateOn = reportToOperateOn;
    this.showDownloadDemo = true;
  }

  closeDownloadDemoPopup() {
    this.reportToOperateOn = undefined;
    this.showDownloadDemo = false;
  }

  showContactFormPopup() {
    this.showContactForm = true;
    let contactFormMessage = "Dzień dobry,\n\n".concat("poproszę o ofertę dotyczącą dostępu do raportu \"",
      this.reportToOperateOn.title,"\"\n\n", "Pozdrawiam\n\n", this.loggedUser.firstName, ' ', this.loggedUser.lastName);

    this.contactForm.controls['message'].setValue(contactFormMessage);
  }

  closeContactFormPopup() {
    this.showContactForm = false;
    UserSearchResultsComponent.contactFormMessage = '';
    this.contactForm.controls['agreement'].reset(false);
    this.contactForm.controls['sendCopy'].reset(false);
  }

  sendAccessRequestToReportClick() {
    let message = this.contactForm.controls['message'].value;
    let sendCopy = this.contactForm.controls['sendCopy'].value;
    this.commonService.sendAccessRequestUrl(this.loggedUser.id, this.reportToOperateOn.id, message, sendCopy).subscribe(
      result => {
        if (result.status ==1)
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
            "Wysłano prośbę o dostęp do raportu");
        else
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystąpił błąd! Nie wysłano maila z prośbą o dostęp")
      },
      error => {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
          "Wystąpił błąd! Nie wysłano maila z prośbą o dostęp")
      }
    );
    this.closeContactFormPopup();
  }

  showReportSharePopup(show : boolean, reportToOperateOn? : Report) {
    this.showReportShare = show;

    if (reportToOperateOn)
      this.reportToOperateOn = reportToOperateOn;

    if (!show)
      this.reportToOperateOn = undefined;
    else
      this.shareReportForm.controls['email'].setValue('');
  }

  shareReportClick() {
    let email = this.shareReportForm.controls['email'].value;
    let message = this.shareReportForm.controls['message'].value;
    this.commonService.shareReport(this.reportToOperateOn.id, this.loggedUser.id, email, message).subscribe(
      result=>{
        if (result.status==1)
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION, "Wysłano link do raportu");
        else
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd: Link nie został wysłany");

        this.showReportShare = false;
        this.reportToOperateOn = undefined;
        this.shareReportForm.controls['email'].reset('');
        this.shareReportForm.controls['message'].reset('');
      });
  }

}
